export * from './components/Slider/index';
//# sourceMappingURL=Slider.js.map